export const emailRegex: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const phoneRegex: RegExp = /^0([2378]\d{8}|[45]\d{8}|14\d{7})$/;
